module.exports = flarum.extensions['fof-upload'];